import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, type ExternalRequest, type PostRequisitesResponse, type StoreBaseReturn } from '@shared/api';

interface UseExternalStore {
  data?: PostRequisitesResponse | null;
  loading: boolean;
  error: string | null;
  createExternal: (request: ExternalRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<PostRequisitesResponse | null>>;
  clear: () => void;
}

export const useExternalStore = create<UseExternalStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  createExternal: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await PaymentsApi.external(request, signal);
      set({ loading: false, data: result || null });
      return { loading: false, data: result || null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: null, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
